<template>
  <div class="bg">
    <div class="container">
      <div class="titleDocument">
        已有账号，<a @click="login">立即登录</a>
      </div>
      <div class="main">
        <PlateTitle
          title="用户注册"
        />
      </div>
      <Form v-if="!isSuccess" />
      <RegisterSuccess v-if="isSuccess" />
    </div>
  </div>
</template>

<script>

import PlateTitle from '@/components/PlateTitle';
import RegisterSuccess from './components/success.vue';
import Form from './components/form.vue';

export default {
  name: 'Register',
  components: {
    PlateTitle,
    RegisterSuccess,
    Form,
  },
  data() {
    return {
      isSuccess: false,
    };
  },
  mounted() {
    this.isSuccess = false;
  },
  methods: {
    login() {
      this.$router.push({ name: 'login' });
    },
    visSuccess() {
      this.isSuccess = true;
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  overflow: hidden;
  background: url("~@/assets/info/login_bg.png") no-repeat;
  background-position: center;
  background-size: cover;
  height: 847px;
  width: 100%;
}
.container{
  background-color: #fff;
  width: 388px;
  margin: 30px auto 80px;
  position: absolute;
  top: 21.6%;
  right: 15.3%;
  .titleDocument {
    position: absolute;
    top: 36px;
    right: 34px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
}
.main{
  padding: 30px 34px 0 34px;
}
a{
  color: #0E52D4;
}
</style>
